import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy } from '@fortawesome/pro-solid-svg-icons/faTrophy';
import { makeStyles } from '@mui/styles';
import { utils } from '@qualifio/ui-commons';

const useStyles = makeStyles(({ spacing, palette }: Theme) => ({
  root: {
    fontSize: utils.pxToRem(11),
  },
  icon: {
    color: palette.primary.main,
    fontSize: '0.7em',
    marginRight: spacing(0.5),
    position: 'relative',
    top: '-0.15em',
  },
  highlight: {
    color: palette.primary.main,
  },
}));

interface Props {
  won?: number;
  total?: number;
  sx?: SxProps;
}

export function RewardListItemInfo({ won = 0, total = 0, sx }: Props): React.ReactElement {
  const classes = useStyles();

  return (
    <Box component="span" className={classes.root} sx={sx}>
      <FontAwesomeIcon className={classes.icon} icon={faTrophy} />
      <span className={classes.highlight}>{won}</span>/{total}
    </Box>
  );
}
